import React from "react";

const RejectedIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38.995"
      height="40.779"
      viewBox="0 0 38.995 40.779"
    >
      <g id="db89" transform="translate(-178.508 -169.519)">
        <path
          id="Path_1783"
          data-name="Path 1783"
          d="M379.738,385.762a.915.915,0,0,0-1.325,0l-1.183,1.183a.915.915,0,0,0,0,1.325l3.076,3.123-3.076,3.075a.915.915,0,0,0,0,1.325l1.183,1.183a.915.915,0,0,0,1.325,0l3.076-3.123,3.076,3.123a.915.915,0,0,0,1.325,0l1.183-1.183a.915.915,0,0,0,0-1.325l-3.028-3.076,3.076-3.076a.915.915,0,0,0,0-1.325l-1.183-1.183a.915.915,0,0,0-1.325,0l-3.076,3.076Z"
          transform="translate(-178.611 -194.381)"
          fill={fill ? fill : "#fb9f34"}
        />
        <path
          id="Path_1784"
          data-name="Path 1784"
          d="M250.5,315.14h5.205a.949.949,0,0,0,.946-.946v-1.656a.949.949,0,0,0-.946-.946H250.5a.949.949,0,0,0-.946.946v1.656A.949.949,0,0,0,250.5,315.14Z"
          transform="translate(-63.95 -127.876)"
          fill={fill ? fill : "#fb9f34"}
        />
        <path
          id="Path_1785"
          data-name="Path 1785"
          d="M250.5,244.1h15.852a.949.949,0,0,0,.946-.946V241.5a.949.949,0,0,0-.946-.946H250.5a.949.949,0,0,0-.946.946v1.656A.949.949,0,0,0,250.5,244.1Z"
          transform="translate(-63.95 -63.934)"
          fill={fill ? fill : "#fb9f34"}
        />
        <path
          id="Path_1786"
          data-name="Path 1786"
          d="M181.064,204.818l2.745-1.372,2.745,1.372a1.913,1.913,0,0,0,1.609,0l2.745-1.372,2.366,1.183a13.317,13.317,0,1,0,21.813-15.284,13.021,13.021,0,0,0-4.684-4.117V173.068a3.544,3.544,0,0,0-3.549-3.549h-24.8a3.544,3.544,0,0,0-3.549,3.549v30.189a1.788,1.788,0,0,0,1.751,1.8,2.271,2.271,0,0,0,.8-.237ZM214,197.011a9.771,9.771,0,1,1-9.795-9.748A9.734,9.734,0,0,1,214,197.011Zm-31.94-23.943H206.9V184a13.178,13.178,0,0,0-14.432,6.814h-5.915a.949.949,0,0,0-.946.946v1.656a.949.949,0,0,0,.946.946h4.637a12.728,12.728,0,0,0,0,5.347,1.869,1.869,0,0,0-1.041.142l-2.745,1.372-2.792-1.372a1.913,1.913,0,0,0-1.609,0l-.994.473Z"
          transform="translate(0)"
          fill={fill ? fill : "#fb9f34"}
        />
      </g>
    </svg>
  );
};

export default RejectedIcon;
